
/**
 * LocalStorage object facades for localStorage instance
 *
 * @type       {Object}
 */
export const LocalStorage = {
  _parseIn: function (data) {
    return JSON.stringify(data);
  },
  _parseOut: function (data) {
    if (data === null || data === undefined) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      console.warn('Failed to parse storage data:', e, data);
      return null;
    }
  },
  set: function (name, data) {
    localStorage.setItem(name, this._parseIn(data));
  },
  get: function (name) {
    const item = localStorage.getItem(name);
    if (item === null) {
      return null;
    }
    return this._parseOut(item);
  },
  has: function (name) {
    return localStorage.getItem(name) !== null;
  },
  remove: function (name) {
    localStorage.removeItem(name);
  },
  clear: function () {
    localStorage.clear();
  }
}

/**
 * SessionStorage object facades for SessionStorage instance
 *
 * @type       {Object}
 */
export const SessionStorage = {
  _parseIn: function (data) {
    return JSON.stringify(data);
  },
  _parseOut: function (data) {
    if (data === null || data === undefined) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      console.warn('Failed to parse storage data:', e, data);
      return null;
    }
  },
  set: function (name, data) {
    sessionStorage.setItem(name, this._parseIn(data));
  },
  get: function (name) {
    const item = sessionStorage.getItem(name);
    if (item === null) {
      return null;
    }
    return this._parseOut(item);
  },
  has: function (name) {
    return sessionStorage.getItem(name) !== null;
  },
  remove: function (name) {
    sessionStorage.removeItem(name);
  },
  clear: function () {
    sessionStorage.clear();
  }
}